var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('modules/uv-shared-module/Shell',["require", "exports", "./BaseEvents", "./BaseView", "./GenericDialogue"], function (require, exports, BaseEvents_1, BaseView_1, GenericDialogue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Shell = /** @class */ (function (_super) {
        __extends(Shell, _super);
        function Shell($element) {
            return _super.call(this, $element, true, true) || this;
        }
        Shell.prototype.create = function () {
            var _this = this;
            _super.prototype.create.call(this);
            this.component.subscribe(BaseEvents_1.BaseEvents.SHOW_OVERLAY, function () {
                _this.$overlays.show();
            });
            this.component.subscribe(BaseEvents_1.BaseEvents.HIDE_OVERLAY, function () {
                _this.$overlays.hide();
            });
            this.$headerPanel = $('<div class="headerPanel"></div>');
            this.$element.append(this.$headerPanel);
            this.$mainPanel = $('<div class="mainPanel"></div>');
            this.$element.append(this.$mainPanel);
            this.$centerPanel = $('<div class="centerPanel"></div>');
            this.$mainPanel.append(this.$centerPanel);
            this.$leftPanel = $('<div class="leftPanel"></div>');
            this.$mainPanel.append(this.$leftPanel);
            this.$rightPanel = $('<div class="rightPanel"></div>');
            this.$mainPanel.append(this.$rightPanel);
            this.$footerPanel = $('<div class="footerPanel"></div>');
            this.$element.append(this.$footerPanel);
            this.$mobileFooterPanel = $('<div class="mobileFooterPanel"></div>');
            this.$element.append(this.$mobileFooterPanel);
            this.$overlays = $('<div class="overlays"></div>');
            this.$element.append(this.$overlays);
            this.$genericDialogue = $('<div class="overlay genericDialogue" aria-hidden="true"></div>');
            this.$overlays.append(this.$genericDialogue);
            this.$overlays.on('click', function (e) {
                if ($(e.target).hasClass('overlays')) {
                    e.preventDefault();
                    _this.component.publish(BaseEvents_1.BaseEvents.CLOSE_ACTIVE_DIALOGUE);
                }
            });
            // create shared views.
            new GenericDialogue_1.GenericDialogue(this.$genericDialogue);
        };
        Shell.prototype.resize = function () {
            var _this = this;
            _super.prototype.resize.call(this);
            setTimeout(function () {
                _this.$overlays.width(_this.extension.width());
                _this.$overlays.height(_this.extension.height());
            }, 1);
            var mainHeight = this.$element.height() - parseInt(this.$mainPanel.css('paddingTop'))
                - (this.$headerPanel.is(':visible') ? this.$headerPanel.height() : 0)
                - (this.$footerPanel.is(':visible') ? this.$footerPanel.height() : 0)
                - (this.$mobileFooterPanel.is(':visible') ? this.$mobileFooterPanel.height() : 0);
            this.$mainPanel.height(mainHeight);
        };
        return Shell;
    }(BaseView_1.BaseView));
    exports.Shell = Shell;
});
//# sourceMappingURL=Shell.js.map
